import { createPinia } from 'pinia';
import { createApp, h } from 'vue';
import { config } from './config';

import App from './App.vue';
import router from './router';

import VueProgressBar from "@aacassandra/vue3-progressbar";
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

const options = {
  color: "#bffaf3",
  failedColor: "#874b4b",
  thickness: "5px",
  transition: {
    speed: "0.2s",
    opacity: "0.6s",
    termination: 300,
  },
  autoRevert: true,
  location: "left",
  inverse: false,
};

// Log environment information
console.log(
  '%cEnvironment: %c' + config.environment,
  'color: #2196F3; font-weight: bold;',
  'color: #4CAF50; font-weight: bold;'
);

console.log(
  '%cAPI Base URL: %c' + config.API_BASE_URL,
  'color: #2196F3; font-weight: bold;',
  'color: #4CAF50; font-weight: bold;'
);

console.log(
  '%cMode: %c' + process.env.NODE_ENV,
  'color: #2196F3; font-weight: bold;',
  'color: #4CAF50; font-weight: bold;'
);

const app = createApp({
  render: () => h(App)
});

const pinia = createPinia();

app.use(router);
app.use(pinia);
app.use(VueProgressBar, options);
app.use(Toast);

app.mount('#app');

// Initialize auth store (Supabase auth listener)
import { useAuthStore } from './stores/authStore';
const authStore = useAuthStore();
authStore.init();
